export default [
  // gigsManagement
  {
    path: "/apps/shifts-&-gigs/gigs-management/list",
    name: "apps-gigs-management-list",
    component: () => import('@/1-shifts-&-gigs/gigs-management/gig-list/GigList.vue'),
    meta: {
      layout: 'vertical',
      authRequired: true,
      resource: "shifts-&-gigs",
      action: "read"
    }
  },
  // shiftsCalendar
  {
    path: "/apps/shifts-&-gigs/shifts-calendar/",
    name: "apps-shifts-calendar",
    component: () => import('@/1-shifts-&-gigs/shifts-calendar/Calendar.vue'),
    meta: {
      authRequired: true,
      resource: "shifts-&-gigs",
      action: "read"
    }
  },
  // areasManagement
  {
    path: "/apps/shifts-&-gigs/areas-management/list",
    name: "apps-areas-management-list",
    component: () => import('@/1-shifts-&-gigs/areas-management/areas-list/AreasList.vue'),
    meta: {
      authRequired: true,
      resource: "shifts-&-gigs",
      action: "read"
    }
  },
  // action-center
  {
    path: "/apps/shifts-&-gigs/action-center/",
    name: "apps-action-center",
    component: () => import('@/1-shifts-&-gigs/action-center/action-center-list/ActionCenterList.vue'),
    meta: {
      authRequired: true,
      resource: "shifts-&-gigs",
      action: "read"
    }
  },
  // requests
  {
    path: "/apps/shifts-&-gigs/requests/",
    name: "apps-requests",
    component: () => import('@/1-shifts-&-gigs/requests/request-list/RequestList.vue'),
    meta: {
      authRequired: true,
      resource: "shifts-&-gigs",
      action: "read"
    }
  },
  {
    path: "/apps/shifts-&-gigs/requests/view/:id",
    name: "apps-requests-view",
    component: () => import('@/1-shifts-&-gigs/requests/request-view/RequestView.vue'),
    meta: {
      authRequired: true,
      resource: "shifts-&-gigs",
      action: "read"
    }
  },
  // reports
  {
    path: "/apps/shifts-&-gigs/reports/",
    name: "apps-reports",
    component: () => import('@/1-shifts-&-gigs/reports/report-list/ReportList.vue'),
    meta: {
      authRequired: true,
      resource: "shifts-&-gigs",
      action: "read"
    }
  },
   // reviews
  {
    path: "/apps/shifts-&-gigs/reviews/",
    name: "apps-reviews",
    component: () => import('@/1-shifts-&-gigs/reviews/reviews-list/ReviewList.vue'),
    meta: {
      authRequired: true,
      resource: "shifts-&-gigs",
      action: "read"
    }
  },
  {
    path: "/apps/shifts-&-gigs/reviews/:id",
    name: "apps-reviews-view",
    component: () => import('@/1-shifts-&-gigs/reviews/reviews-view/ReviewView.vue'),
    meta: {
      authRequired: true,
      resource: "shifts-&-gigs",
      action: "read"
    }
  }
]